module.exports = __webpack_public_path__ + "img/chart-scatter-bubble.224f9a02.svg";